<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" :initialFocus="activeElement" @close="closeModal">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-50" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="
                inline-block
                w-full
                max-w-screen-sm
                p-6
                m-auto
                overflow-hidden
                text-left
                align-middle
                transition-all
                transform
                bg-white
                shadow-xl
                rounded
              "
            >
              <div class="flex flex-row pb-4">
                <div class="flex-1">
                  <h3 class="text-xl leading-6 text-brand-black">Notice</h3>
                </div>
                <div class="flex-4 cursor-pointer" @click.prevent="closeModal">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="py-4">
                <p class="text-brand-black">
                  Looks like you're logged in as {{ getCurrentUser.username}} and applying
                  to {{ host }}/{{ getCurrentApplicationTemplate.slug }}. Please
                  note that this will submit the application to yourself.
                </p>
              </div>
              <div class="py-4">
                <div class="w-full md:w-1/2 mx-auto">
                  <PrimaryButton @click.prevent="closeModal" ref="actionButton"
                    >Continue anyway</PrimaryButton
                  >
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters(["getCurrentApplicationTemplate", "getCurrentUser"]),
    host() {
      return location.origin
    },
    activeElement() {
      return document.activeElement
    }
  },
  methods: {
    closeModal() {
      this.$emit("close")
    }
  }
}
</script>
